import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Icon from '../ui/Icon';
import { TOOL_CATEGORIES } from '../../data/tools';

const ToolCard = ({ tool, index = 0, variant = 'default' }) => {
  const cat = TOOL_CATEGORIES[tool.category];

  if (variant === 'compact') {
    return (
      <Link to={`/tool/${tool.id}`}>
        <motion.div
          whileHover={{ y: -2 }}
          className="flex items-center gap-3 p-3 rounded-xl transition-colors cursor-pointer"
          style={{ border: '1px solid var(--border-light)' }}
        >
          <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
            style={{ background: cat.bgLight, color: cat.color }}>
            <Icon name={tool.icon} size={16} />
          </div>
          <div className="min-w-0">
            <p className="text-sm font-medium truncate" style={{ color: 'var(--text-primary)' }}>{tool.name}</p>
            <p className="text-xs truncate" style={{ color: 'var(--text-muted)' }}>{tool.desc}</p>
          </div>
        </motion.div>
      </Link>
    );
  }

  if (variant === 'featured') {
    return (
      <Link to={`/tool/${tool.id}`}>
        <motion.div
          whileHover={{ y: -4, scale: 1.01 }}
          className="relative overflow-hidden rounded-2xl p-6 h-full cursor-pointer group"
          style={{
            background: `linear-gradient(135deg, ${cat.color}12, ${cat.color}06)`,
            border: `1px solid ${cat.color}20`,
          }}
        >
          <div className="absolute top-0 right-0 w-32 h-32 rounded-full opacity-10 -translate-y-1/2 translate-x-1/2"
            style={{ background: cat.color }} />
          <div className="relative z-10">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4"
              style={{ background: cat.bgMedium, color: cat.color }}>
              <Icon name={tool.icon} size={22} />
            </div>
            <h3 className="text-lg font-bold mb-1" style={{ color: 'var(--text-primary)' }}>{tool.name}</h3>
            <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>{tool.desc}</p>
            <div className="mt-4 flex items-center gap-1 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity"
              style={{ color: cat.color }}>
              Open tool <Icon name="ArrowRight" size={14} />
            </div>
          </div>
        </motion.div>
      </Link>
    );
  }

  // Default card
  return (
    <Link to={`/tool/${tool.id}`}>
      <motion.div
        whileHover={{ y: -3 }}
        transition={{ duration: 0.25 }}
        className="card p-5 h-full cursor-pointer group"
      >
        <div className="flex items-start gap-4">
          <div className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 transition-transform group-hover:scale-110"
            style={{ background: cat.bgLight, color: cat.color }}>
            <Icon name={tool.icon} size={20} />
          </div>
          <div>
            <h3 className="text-sm font-bold mb-0.5" style={{ color: 'var(--text-primary)' }}>{tool.name}</h3>
            <p className="text-xs leading-relaxed" style={{ color: 'var(--text-muted)' }}>{tool.desc}</p>
          </div>
        </div>
        {tool.popular && (
          <div className="mt-3 pt-3" style={{ borderTop: '1px solid var(--border-light)' }}>
            <span className="badge-brand text-[10px]">
              <Icon name="Star" size={10} className="mr-1" /> Popular
            </span>
          </div>
        )}
      </motion.div>
    </Link>
  );
};

export default ToolCard;
